// Common TextField styles utility
// Based on the search input styling pattern used throughout the application

export const commonTextFieldStyles = {
  '& .MuiOutlinedInput-root': {
    height: '56px',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#cbd5e1',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 3px rgb(59 130 246 / 0.1)',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#d4d4d4',
  },
};

// For TextFields that need additional styling (like disabled states)
export const commonTextFieldStylesWithDisabled = {
  ...commonTextFieldStyles,
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: '#f8fafc',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e2e8f0',
    },
  },
};

// For multiline TextFields (TextArea style)
export const commonTextAreaStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#cbd5e1',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 3px rgb(59 130 246 / 0.1)',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#d4d4d4',
  },
};